import { SUPPORT_CENTER_BUTTON_CONFIG } from '../top-header.config';
import { HeaderItem, HeaderItemType, TopHeader } from '@mkp/layout/models';
import { getButtonPlatformClass } from '@mkp/shared/util-platform';

export const getItemsConfig = (topHeader: TopHeader): Record<string, Record<string, unknown>> => {
  return {
    login_link: getLoginLinkConfig(topHeader),
    lang_menu: getLangMenuConfig(topHeader),
    one_logo: getOneLogoConfig(topHeader),
    one_logo_link: getOneLogoLinkConfig(topHeader),
  };
};

export const getLoginLinkConfig = (topHeader: TopHeader) =>
  findConfig('login_link', topHeader)?.options || {
    buttonConfig: { ...SUPPORT_CENTER_BUTTON_CONFIG },
    platformStyle: false,
  };
export const getLangMenuConfig = (topHeader: TopHeader) =>
  findConfig('lang_menu', topHeader)?.options || { platformStyle: false };
export const getOneLogoConfig = (topHeader: TopHeader) =>
  findConfig('one_logo', topHeader)?.options || { disabled: false, isRightPosition: false };
export const getOneLogoLinkConfig = (topHeader: TopHeader) =>
  findConfig('one_logo_link', topHeader)?.options || { disabled: false, isRightPosition: false };

export const findConfig = (type: HeaderItemType, topHeader: TopHeader) => {
  return (
    topHeader.leftBoxContent?.find((item) => item.type === type) ||
    topHeader.rightBoxContent?.find((item) => item.type === type)
  );
};

export const getLoginLinkPlatformConfig = (topHeader: TopHeader, platformGroup: string) => {
  return {
    ...getItemsConfig(topHeader),
    login_link: {
      platformStyle: true,
      buttonConfig: {
        ...getLoginLinkConfig(topHeader).buttonConfig,
        classList: getButtonPlatformClass(`secondary-${platformGroup}`),
      },
    },
  };
};

export const areHeaderItemsEqual = (
  prev: HeaderItem[] | undefined,
  curr: HeaderItem[] | undefined
): boolean => {
  return prev?.length === curr?.length && compareItems(prev, curr);
};

export const compareItems = (
  prev: HeaderItem[] | undefined,
  curr: HeaderItem[] | undefined
): boolean => {
  return !!prev?.every(
    (item, index) =>
      item.type === curr?.[index].type &&
      JSON.stringify(item.options) === JSON.stringify(curr?.[index].options)
  );
};
